export function pathFromPolicyId(id: string | null | undefined): string | null {
  return id ? `policies/${id}.md` : null;
}

export function pathFromProcedureId(
  id: string | null | undefined
): string | null {
  return id ? `procedures/${id}.md` : null;
}

export function pathFromReferenceId(
  id: string | null | undefined
): string | null {
  return id ? `ref/${id.replace(/^ref-/, '')}.md` : null;
}

export function pathForSecurityVertex(vertex: any): string | null {
  const id = vertex.properties.id || vertex.properties.name;
  switch (vertex.entity._type?.[0]) {
    case 'security_policy': {
      return pathFromPolicyId(id);
    }
    case 'security_procedure': {
      return pathFromProcedureId(id);
    }
    case 'security_document': {
      return pathFromReferenceId(id);
    }
    default: {
      return null;
    }
  }
}
